import Pagination from "./Pagination.vue";
import { pluginify } from "./../../util";
export default pluginify(Pagination);
export { Pagination };
